import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const AppProviders = lazy(() => import('@app/components/AppProviders'))
const UploadEmpty = lazy(() => import('.'))

class UploadEmptyComponent extends ReactWebComponent {
	static get observedAttributes() {
		return []
	}

	override render() {
		return (
			<AppProviders>
				<UploadEmpty />
			</AppProviders>
		)
	}
}

customElements.define('upload-empty', UploadEmptyComponent)
